module.exports = __webpack_public_path__ + "static/media/googleCalendarIcon.d5e4713d.svg";